import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "text", "more", "full", "less"]

  connect() {
    if (!this.hasTextTarget) return

    document.fonts.ready.then(() => {
      if (this.textTarget.scrollHeight > this.textTarget.clientHeight + 4) this.moreTarget.classList.remove("hidden")
    })
  }

  open(event) {
    if (this.moreTarget.classList.contains("hidden")) return

    event.preventDefault()
    if (this.loaded) return this.show()
    if (this.fullTarget.src) return

    this.moreTarget.textContent = "Loading\u2026"
    this.fullTarget.src = this.fullTarget.dataset.src
  }

  show() {
    this.loaded = true
    this.moreTarget.textContent = "See More"
    this.previewTarget.classList.add("hidden")
    this.fullTarget.classList.remove("hidden")
    this.lessTarget.classList.remove("hidden")
  }

  close() {
    this.fullTarget.classList.add("hidden")
    this.lessTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")

    const navbarHeight = document.getElementById("navbar")?.offsetHeight || 0
    const top = this.element.getBoundingClientRect().top
    if (top < navbarHeight) window.scrollBy({ top: top - navbarHeight - 8 })
  }
}
